import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedReactMessage';
import FormattedList from 'I18n/components/FormattedList';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { WEB_FONT_MEDIUM_WEIGHT } from 'HubStyleTokens/misc';
import { CANDY_APPLE } from 'HubStyleTokens/colors';
// @ts-expect-error untyped module
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import SlackChannelName from 'automation-ui-references/reference-resolvers/SlackChannelName';
import SlackUserName from 'automation-ui-references/reference-resolvers/SlackUserName';
import PersonalizedTextView from 'automation-ui-action-features/personalized-text/PersonalizedTextView';
import SlackActionMetadata from 'automation-ui-action-features/actions/slack/records/SlackActionMetadata';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledProp = styled.span.withConfig({
  displayName: "SlackActionDetail__StyledProp",
  componentId: "sc-1pblows-0"
})(["font-weight:", ";"], WEB_FONT_MEDIUM_WEIGHT);
const StyledPropMissing = styled.span.withConfig({
  displayName: "SlackActionDetail__StyledPropMissing",
  componentId: "sc-1pblows-1"
})(["font-weight:", ";color:", ";"], WEB_FONT_MEDIUM_WEIGHT, CANDY_APPLE);
export default class SlackActionDetail extends Component {
  constructor(...args) {
    super(...args);
    this.propTypes = {
      actionMetadata: PropTypes.instanceOf(SlackActionMetadata).isRequired,
      flowObjectTypeId: ObjectTypeIdType.isRequired,
      messageLangPath: PropTypes.string
    };
    this.defaultProps = {
      messageLangPath: 'actionDetail'
    };
  }
  renderMergedRecipientList(slackUserIds = [], slackChannelIds = [], recipientOwnerProperties = []) {
    const {
      flowObjectTypeId
    } = this.props;
    if (!slackUserIds.length && !slackChannelIds.length && !recipientOwnerProperties.length) {
      return /*#__PURE__*/_jsx(StyledPropMissing, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-action-features.action-features.slack.missing-recipients"
        })
      });
    }
    const usersAndChannelsList = /*#__PURE__*/_jsxs(FormattedList, {
      children: [slackUserIds.map(slackUserId => /*#__PURE__*/_jsx(SlackUserName, {
        id: slackUserId
      }, slackUserId)), slackChannelIds.map(slackChannelId => /*#__PURE__*/_jsx(SlackChannelName, {
        id: slackChannelId
      }, slackChannelId)), recipientOwnerProperties.map(propertyName => /*#__PURE__*/_jsx(PropertyName, {
        objectTypeId: flowObjectTypeId,
        propertyName: propertyName
      }, propertyName))]
    });
    return /*#__PURE__*/_jsx(StyledProp, {
      children: usersAndChannelsList
    });
  }
  renderProperties(flowObjectTypeId, objectProperties) {
    return /*#__PURE__*/_jsx(FormattedList, {
      children: objectProperties.map(propertyName => /*#__PURE__*/_jsx(PropertyName, {
        objectTypeId: flowObjectTypeId,
        propertyName: propertyName
      }, propertyName))
    });
  }
  render() {
    const {
      actionMetadata: {
        text,
        slackUserIds,
        slackChannelIds,
        recipientOwnerProperties,
        objectProperties
      },
      flowObjectTypeId,
      messageLangPath
    } = this.props;
    const messageOptions = {
      messageText: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(PersonalizedTextView, {
          propertyTypeId: flowObjectTypeId,
          text: `"${text}"`
        })
      }),
      recipients: /*#__PURE__*/_jsx(StyledProp, {
        children: this.renderMergedRecipientList(slackUserIds, slackChannelIds, recipientOwnerProperties)
      }),
      properties: /*#__PURE__*/_jsx(StyledProp, {
        children: this.renderProperties(flowObjectTypeId, objectProperties)
      })
    };
    return messageLangPath === 'actionDetail' ? objectProperties.length ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.slack.action-detail.content.properties",
      options: messageOptions
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.slack.action-detail.content.no-properties",
      options: messageOptions
    }) : objectProperties.length ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.slack.action-preview.content.properties",
      options: messageOptions
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.slack.action-preview.content.no-properties",
      options: messageOptions
    });
  }
}